import styled from '@emotion/styled'

import { ArrowGlyph, cardBorderColor, MobileCardFrame } from '../../../../components/advice/shared'
import { VALUE_COLUMN_WIDTH, HEADER_TO_ROWS_GAP, nameGutterStyles } from '../../elements'

export { HeaderRow, ValueRow, ValueColumnHeading, BalanceGutter } from '../../elements'

export const Heading = styled.h1`
  font-family: 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: 1.875rem;
  font-weight: 400;
  line-height: 1.3;
  text-align: center;
  max-width: 720px;
  margin: 0 0 48px;
  color: ${p => p.theme.mediumGray};

  strong {
    color: ${p => p.theme.darkestGray};
  }

  @media (max-width: 600px) {
    font-size: 1.5rem;
  }
`

export const LastWord = styled.span`
  white-space: nowrap;
`

export const HelpAnchor = styled.span`
  display: inline-block;
  vertical-align: middle;
  margin-left: 6px;
  transform: translateY(-0.05em);
`

// --- Desktop table ---

const PERSON_ROW_GAP = '16px'

export const DesktopTable = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: ${HEADER_TO_ROWS_GAP};
`

export const PersonRows = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${PERSON_ROW_GAP};
`

export const NameLabel = styled.div`
  ${nameGutterStyles}
  font-size: 13px;
  font-weight: 600;
  color: ${p => p.theme.darkestGray};
`

export const Cell = styled.div`
  box-sizing: border-box;
  width: ${VALUE_COLUMN_WIDTH};
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-weight: 400;
  background: ${p => (p.planned ? p.theme.ternaryColor : p.theme.addButtonHoverColor)};
  color: ${p => (p.planned ? p.theme.primaryColor : p.theme.mediumGray)};
`

// --- Mobile table ---

export const MobileCard = styled(MobileCardFrame)`
  box-sizing: border-box;
  width: 100%;
  max-width: 400px;
  padding: 13px 30px 30px;
`

export const MobileTitle = styled.div`
  text-align: center;
  font-weight: 600;
  font-size: 13px;
  color: ${p => p.theme.darkestGray};
`

export const MobileSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 20px;
  margin-top: 32px;
`

export const MobileSectionName = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: ${p => p.theme.mediumGray};
`

export const MobileDivider = styled.hr`
  width: 100%;
  border: none;
  border-top: 2px solid ${cardBorderColor};
  margin: 32px 0 0;
`

export const MobileValueRow = styled.div`
  display: flex;
  align-items: center;
  column-gap: 28px;
`

// Planned values are semibold unless there is no change.
export const MobileValue = styled.div`
  min-width: 80px;
  text-align: center;
  font-size: 15px;
  font-weight: ${p => (p.planned && !p.noChange ? 600 : 400)};
  color: ${p => (p.planned ? p.theme.primaryColor : p.theme.mediumGray)};
`

export const MobileArrow = styled(ArrowGlyph)`
  flex: 0 0 auto;
  color: ${p => p.theme.primaryColor};
`
